import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// ============================================================================
// Rendelés-napló a rendelés oldal jobb oszlopában: ki, mikor, mit módosított
// (régi → új érték). Ha még nincs módosítás, nem látszik.
// ============================================================================

export interface OrderChange {
  id: number;
  action: string;
  userId: number | null;
  userName: string | null;
  createdAt: string;
  note: string | null;
  changes: { field: string; label: string; old: string | null; new: string | null }[];
}

const ACTION_LABEL: Record<string, string> = {
  address: 'Cím / vevőadatok módosítva',
  tracking: 'Csomagszám módosítva',
  package: 'Csomag módosítva',
  packaging: 'Csomagolás',
  label: 'Címke',
  invoice: 'Számla',
  archive: 'Archiválás',
  restore: 'Visszaállítás',
  product_add: 'Tétel hozzáadva',
  product_remove: 'Tétel kivéve',
  personalization_edit: 'Személyre szabás átírva',
  product_restore: 'Tétel visszavéve',
  replacement: 'Pótküldés',
  created: 'Létrehozva',
};

@Component({
  selector: 'app-order-change-log',
  templateUrl: './order-change-log.component.html',
  styleUrl: './order-change-log.component.scss',
})
export class OrderChangeLogComponent implements OnChanges {
  @Input() orderId?: number | null;
  /** a rendelés újratöltésekor változik → a napló is frissül */
  @Input() version?: unknown;

  items: OrderChange[] = [];
  loaded = false;
  showAll = false;

  constructor(private http: HttpClient) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId'] || changes['version']) {
      this.load();
    }
  }

  load(): void {
    const id = Number(this.orderId);
    if (!id) return;
    this.http.get<OrderChange[]>(`orders/${id}/changes`).subscribe({
      next: (items) => {
        if (Number(this.orderId) !== id) return;
        this.items = items || [];
        this.loaded = true;
      },
      error: () => (this.loaded = true),
    });
  }

  get visible(): OrderChange[] {
    return this.showAll ? this.items : this.items.slice(0, 5);
  }

  actionLabel(item: OrderChange): string {
    return ACTION_LABEL[item.action] || item.action;
  }

  /** tételnél: új tétel / kivett tétel szövege */
  productText(change: OrderChange['changes'][number]): string {
    if (!change.old) return `+ ${change.new}`;
    if (!change.new) return `− ${change.old}`;
    return `${change.old} → ${change.new}`;
  }

  isProduct(change: OrderChange['changes'][number]): boolean {
    return change.field.startsWith('product:');
  }
}
